module.exports = __webpack_public_path__ + "img/sec-a.575fb4a7.svg";